import React from 'react';

import socketio from "socket.io-client";

export const socket = socketio.connect(process.env.REACT_APP_SOCKET_URL,{
    auth: { token: localStorage.getItem("userId") }
  });
socket.on('connect', (err) => {
    console.log(`I'm connected with sdsad backdc-end`);
});
export const SocketContext = React.createContext(null);